// hooks/useAcquittalData.js
import { useState, useEffect } from 'react';
import { BASE_URL } from 'utils/axios';

export const useAcquittalData = (acquittalId, keycloakToken) => {
    const [isLoading, setIsLoading] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [lineActivities, setLineActivities] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (!acquittalId || !keycloakToken) return;

            setIsLoading(true);
            setError(null);

            try {
                // Fetch documents
                const documentsResponse = await fetch(`${BASE_URL}/api/acquittals/${acquittalId}/documents?page=0&size=100`, {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${keycloakToken}`
                    }
                });

                // Fetch line activities
                const activitiesResponse = await fetch(`${BASE_URL}/api/acquittals/${acquittalId}/acquittal-line-activities`, {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${keycloakToken}`
                    }
                });

                if (!documentsResponse.ok || !activitiesResponse.ok) {
                    throw new Error('One or more requests failed');
                }

                const [documentsData, activitiesData] = await Promise.all([documentsResponse.json(), activitiesResponse.json()]);

                setDocuments(documentsData.content || []);
                setLineActivities(activitiesData || []);
            } catch (err) {
                console.error('Error fetching acquittal data:', err);
                setError(err.message);
                setDocuments([]);
                setLineActivities([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [acquittalId, keycloakToken]);

    return {
        isLoading,
        documents,
        lineActivities,
        error
    };
};
